import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './common/footer/footer.component';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { AppInterceptor } from './shared/interceptors/app-interceptor';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HeaderbootComponent } from './common/headerboot/headerboot.component';
import { UpcomingVisitsBoxComponent } from './upcoming-visits-box/upcoming-visits-box.component';
import { MatSelectModule } from '@angular/material/select';
import { InternationalizationComponent } from './internationalization/internationalization.component';
import { LoginDialogComponent } from './patients/doctor-profile/components/login-dialog/login-dialog.component';
import { InitService } from './init.service';
import { NotFoundComponent } from './not-found/not-found.component';
// import { SiteMapTestEnvComponent } from './site-map-test-env/site-map-test-env.component';

// This Function initService.initializeApp(); gets execute before app bootstrap
export function initializeAppFactory(initService: InitService): Function {
  return () => initService.initializeApp();
}

@NgModule({
  declarations: [
    AppComponent,
    // Default
    FooterComponent,
    NotFoundComponent,
    HeaderbootComponent,
    UpcomingVisitsBoxComponent,
    InternationalizationComponent,
    LoginDialogComponent,
    // SiteMapTestEnvComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    // ServerModule,
    // ServerTransferStateModule,
    BrowserTransferStateModule,
    MatSelectModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
    }),
    // deps: [HttpClient, TransferState]
    // AngularFireModule.initializeApp(environment.firebase),
    GooglePlaceModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    // { provide: APP_BASE_HREF, useValue: '/site/iHospitalWebTesting/' },
    // { provide: APP_INITIALIZER, useFactory: initializeAppFactory, deps: [InitService], multi: true }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}